import React from 'react';
import { BsFillTagFill } from 'react-icons/bs';
import { BiCalendar } from 'react-icons/bi';
import { ReactComponent as Next } from '../../assets/icons/chevron-right.svg';
import styled from 'styled-components';
import formatPrice from '../../services/utils/formatPrice';
import { FaCreditCard } from 'react-icons/fa';

const PaymentCardRoot = styled.div<{ otherPortions?: boolean }>`
  width: 100%;
  height: ${(props) => (props.otherPortions ? '140px' : '125px')};
  display: flex;
  flex-direction: row;
  background: #ffffff;
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '10px'};
  padding: 20px;

  @media (min-width: 960px) {
    box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
      4px 4px 6px rgba(36, 36, 36, 0.1);
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '60px'};

    padding: 16px 40px;
    height: ${(props) => (props.otherPortions ? '110px' : '90px')};
  }
`;

const PaymentQuantity = styled.div`
  width: 56px;
  height: 56px;
  background: ${(props) => props.theme.colors.primary};
  border-radius: ${(props) =>
    Number(props.theme.borderRadius) ? `${props.theme.borderRadius}px` : '5px'};
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  align-self: center;
  margin-right: 20px;
  padding: 16px;
  color: #ffffff;
  @media (min-width: 960px) {
    width: 48px;
    height: 48px;
    padding: 12px;
    margin-right: 24px;
  }
`;

const PaymentMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  .model {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #7b86a3;
  }

  .portion {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: #070c2f;
  }

  .more-portions {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: #7b86a3;
  }

  .sub-infos {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (min-width: 960px) {
      flex-direction: row;
    }
    .label {
      margin-left: 4px;
    }
  }

  .type {
    display: flex;
    align-items: center;
    span {
      font-family: Font Awesome 5 Free;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: #7b86a3;
      margin-right: 4px;
    }
    span.value {
      font-weight: 900;
    }
  }

  .desktop-divider {
    display: none;
    @media (min-width: 960px) {
      width: 1px;
      height: 14px;
      background: #7b86a3;
      margin: 0 6px;
      font-weight: 900;
      display: flex;
      align-self: center;
    }
  }

  .due-date {
    display: flex;
    align-items: center;
    span {
      font-family: Font Awesome 5 Free;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: #7b86a3;
      margin-right: 4px;
    }
    span.value {
      font-weight: 900;
    }
  }
`;

const PaymentArrowIcon = styled(Next)`
  height: 24px;
  width: 24px;
  display: flex;
  align-self: center;
`;
interface IPayment {
  plan: number;
  firstPortion: number;
  othersPortions?: number;
  type: string;
  paymentMethod?: string;
  dueDate?: string;
  hiddeArrow?: boolean;
}
const PaymentCard: React.FC<IPayment> = ({
  plan,
  firstPortion,
  othersPortions,
  type,
  dueDate,
  hiddeArrow,
  paymentMethod,
}) => {
  return (
    <PaymentCardRoot otherPortions={!!othersPortions}>
      <PaymentQuantity>{`${plan}x`}</PaymentQuantity>
      <PaymentMainInfo>
        <span className='model'>{plan > 1 ? 'Entrada de' : 'À Vista'}</span>
        <span className='portion'>{`R$ ${formatPrice(firstPortion)}`}</span>
        <span className='more-portions' hidden={!!!othersPortions}>
          {`+ ${plan - 1} parcelas de R$ ${formatPrice(othersPortions || 0)}`}
        </span>
        <div className='sub-infos'>
          <div className='type'>
            <BsFillTagFill />
            <span className='label'>Tipo:</span>
            <span className='value'>{type}</span>
            {paymentMethod && paymentMethod !== '' && (
              <span className='space-right space-left'> | </span>
            )}
          </div>

          {paymentMethod && paymentMethod !== '' && (
            <div className='type'>
              <FaCreditCard />
              <span className='label'>Forma de pagamento:</span>
              <span className='value'>{paymentMethod}</span>
            </div>
          )}

          {!!dueDate && <div className='desktop-divider' />}
          <span className='due-date' hidden={!!!dueDate}>
            {!!dueDate && <BiCalendar />}
            <span className='label' hidden={!!!dueDate}>
              Vencimento:
            </span>
            <span className='value' hidden={!!!dueDate}>
              {dueDate}
            </span>
          </span>
        </div>
      </PaymentMainInfo>
      {!hiddeArrow && <PaymentArrowIcon />}
    </PaymentCardRoot>
  );
};

export default PaymentCard;
